import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input<{ isStyle: boolean }>`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: ${(props) => props.isStyle ? `1px solid ${props.theme.colors.gray.gray_600}` : 'none'};
    padding: 10px;
    width: 100%;
    text-align: ${(props) => props.isStyle ? 'start' : 'center'};

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const TextArea = styled.textarea`
    border: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    border-radius: 4px;
    resize: none;

    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const HeadCalc = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    p{
        font-weight: 500;
    }
`;

export const ButtonCalc = styled.button`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.gray.gray_800};

    padding: 8px 15px;
    border-radius: 30px;
`;

//Table
export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 2px 2px 8px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 8px;
    padding: 3px 5px;
    max-height: 350px;
    height: 350px;
`;

export const TotalValue = styled.div`
    display: flex;
    justify-content: flex-end;

    color: ${(props) => props.theme.colors.gray.gray_800};
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    
    tr {
        display: table;
        table-layout: fixed;
        width: 100%;
    }
    
    td,
    th {
        border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
        text-align: center;
        padding: 10px 0;
        font-size: 12px;
    }
`;

export const Thead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    top: 0;
    z-index: 1;

    th{
        font-weight: 500;
        font-size: 14px;
    }
`;

export const Tbody = styled.tbody`
    display: block;
    max-height: 220px;
    overflow-y: auto;
    overflow-x: auto;
    width: 100%;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const Td = styled.td``;

export const Tr = styled.tr``;

export const TdStyle = styled.td`
    font-weight: 500;
    font-size: 14px;
`;

export const ContentInfor = styled.div``;

export const InforTitle = styled.p`
    font-size: 24px;
    font-weight: 500;
`;

export const Infor = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`

export const Subtitle = styled.p`
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const InforDescription = styled.p`
    font-size: 14px;
`;

//PopMenu
export const ContentPopMenu = styled.div`
    width: 100%;
    position: relative;
`;

export const PopMenu = styled.div`
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 5px 3px;

    max-height: 100px;
    overflow-y: scroll;
    

    &::-webkit-scrollbar { 
        display: none;
    }

    span{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};
        padding: 5px 10px;
    }
`;

export const ButtonMenu = styled.button`
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
  }
`;
//Fim PopMenu